import { z } from 'zod';

export const JWTTokenSchema = z.object({
  exp: z.number(),
  iat: z.number(),
});

export const AccessTokenPayloadSchema = JWTTokenSchema.extend({
  id: z.string(),
  email: z.string().email(),
  role: z.string(),
  isConfirmed: z.boolean(),
  isActive: z.boolean(),
  completedProfile: z.boolean(),
});

export type AccessTokenPayload = z.infer<typeof AccessTokenPayloadSchema>;
